import React from "react"
import FailModal from "./modal/FailModal"
import LoadingModal from "./modal/LoadingModal"
import SuccessModal from "./modal/SuccessModal"
import ConfirmationModal from "./modal/ConfirmationModal"
import { useModal } from "utils/context/ModalContext"

const GlobalModals = () => {
    const {
        failModal,
        loading,
        successModal,
        hideFail,
        hideLoading,
        hideSuccess,
        confirmationModal,
        handleConfirm,
        handleCancel
    } = useModal()

    return (
        <>
            {failModal?.isOpen && (
                <FailModal
                    onClose={hideFail}
                    data={failModal?.data}
                    message={failModal?.message}
                />
            )}

            {loading?.isOpen && (
                <LoadingModal
                    onClose={hideLoading}
                />
            )}

            {successModal?.isOpen && (
                <SuccessModal
                    onClose={hideSuccess}
                    data={successModal?.data}
                />
            )}

            {confirmationModal?.isOpen && (
                <ConfirmationModal
                    message={confirmationModal?.message}
                    onConfirm={handleConfirm}
                    onCancel={handleCancel}
                />
            )}
        </>
    )
}

export default GlobalModals